<div class="editor-container" #editorContainer></div>